import { DownOutlined, UpOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useMemoizedFn, useSize } from 'ahooks';
import { Button } from 'antd';
import { useRef, useState } from 'react';
import { useTranslate } from '@tolgee/react';

const BASE_HEIGHT = 24;

const Container = styled.div`
  display: flex;
  align-items: start;
  padding: 16px 16px 16px 24px;
`;
const GroupList = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;
const GroupNameButton = styled(Button)`
  &.ant-btn-primary .ant-typography {
    color: #fff;
  }
  > span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
const Fold = styled.div`
  height: ${BASE_HEIGHT}px;
  overflow: hidden;
`;

export interface GroupNavV2Props {
  data?: Phrase.Group[];
  value?: string;
  onChange?: (groupId?: string) => void;
}

const GroupNavV2 = (props: GroupNavV2Props) => {
  const { data, value, onChange } = props;

  const { t } = useTranslate();
  const [isFold, setIsFold] = useState(true);
  const groupListRef = useRef<HTMLDivElement>(null);
  const size = useSize(groupListRef);

  const handleFold = useMemoizedFn(() => {
    setIsFold((val) => !val);
  });
  return (
    <Container>
      <Fold style={{ height: isFold ? BASE_HEIGHT : 'auto' }}>
        <GroupList ref={groupListRef}>
          <Button
            size="small"
            type={value === undefined ? 'primary' : 'default'}
            onClick={() => {
              onChange?.(undefined);
            }}
          >
            {t('review.全部')}
          </Button>
          {data?.map((item) => {
            return (
              <GroupNameButton
                size="small"
                style={{ maxWidth: 120 }}
                type={value === item.id ? 'primary' : 'default'}
                onClick={() => onChange?.(item.id)}
              >
                {item.name}
              </GroupNameButton>
            );
          })}
        </GroupList>
      </Fold>
      {size?.height && size.height > BASE_HEIGHT ? (
        <Button type="link" size="small" onClick={handleFold}>
          {isFold ? t('phrase.展开') : t('phrase.收起')}
          {isFold ? <DownOutlined /> : <UpOutlined />}
        </Button>
      ) : null}
    </Container>
  );
};

export default GroupNavV2;
